module.exports = __webpack_public_path__ + "img/ic_happily@2x.146cc9c1.png";